<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/RepairUsage'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3">
                <div class="form-group ">
                  <label class="label">วันที่ซ่อมเสร็จสิ้น(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">วันที่ซ่อมเสร็จสิ้น(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>BARCODE :</label>
                  <input v-model="qiOldBarcode" type="text" class="form-control" placeholder="BARCODE"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>เลขที่ใบงาน :</label>
                  <input v-model="qiJobNumber" type="text" class="form-control" placeholder="เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ประเภทสินค้า:</label>
                  <treeselect id="jobSubtype" v-model="jobSubtype" :multiple="true" :options="qiJobSubtype"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">เขต:</label>
                  <treeselect id="jobArea" v-model="jobArea" :multiple="true" :options="qiJobAreaOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่อช่าง:</label>
                  <treeselect
                      v-model="qiUserId"
                      :multiple="true"
                      :load-options="LoadUsersIdOptions"
                      :async="true"
                      v-on:open="reLoadUsersIdOptions"
                      v-on:select="ClearAfterselect"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="qiUserId"
                    />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN'])"
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
import Collapsible from "../../Shared/Collapsible";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      jobSubtype: null,
      qiProductCodeOptions: [],
      qiEvalStatusOptions: [],
      qiJobSubtype: [],
      qiUserId: [],
      jobArea: [],
      qiJobAreaOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null,
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      const startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      const today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;
      this.qiProductType = null;
      this.qiProductBrand = null;
      this.qiEvalStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;

      $(`#qiProductCode`).val("").trigger("change");
      $(`#qiProductType`).val("").trigger("change");
      $(`#qiProductBrand`).val("").trigger("change");
      $(`#qiEvalStatus`).val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');

      // this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportRepairUsage",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber,
          QIProductCode: self.qiProductCode,
          QISubtype: self.jobSubtype,
          QIJobArea: self.jobArea,
          QIUserId: self.qiUserId,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiMachine', 'QiEquipment'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadJobAreaOptions: function (e) {
      var self = this;
      self.qiJobAreaOptions = [];
      var data = [
        {
          id: "Plant",
          text: "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด",
        },
        {
          id: "Agent",
          text: "ซ่อมในตัวแทนจำหน่าย",
        },
      ];
      data.forEach((element) => {
        self.qiJobAreaOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    LoadreSubtypeOptions: function (e) {
      var self = this;
      self.qiJobSubtype = [];
      var data = [
        {
          id: "1",
          text: "เครื่องเบียร์สด",
        },
        {
          id: "2",
          text: "อุปกรณ์เบียร์สด",
        },
      ];
      data.forEach((element) => {
        self.qiJobSubtype.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    self.LoadreSubtypeOptions();
    self.LoadJobAreaOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    const today = moment();
    const startOfMonth = moment().startOf('month');
    self.jobsDateStart = startOfMonth;
    self.jobsDateEnd = today;

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', startOfMonth.toDate());
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', today.toDate());
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportRepairUsage.vue